import content from "./content/trading.json";

export const tradingMock = {
  name: "trading",
  layoutType: 1,
  areasList: [
    {
      id: "trading-main",
      componentName: "Comp:TradingPage",
      content: JSON.stringify(content),
    },
  ],
};
